import { useEffect, useState } from "react";
import styled from "styled-components";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead, { tableHeadClasses } from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { useLanguage } from "@/app/utils/LanguageContext";
import Disclaimer from "@/app/ui/Disclaimer";
import { useMyContext } from '@/app/utils/MyContext';
import { getJockeysTrainersRanking } from '@/app/utils/request/requestList';
import { PlainTextTable } from "@/app/utils/class/cms";
import { textSize, text_size } from "@/app/utils/MixinSize";
import NoInformation from "@/app/ui/Common/NoInformation";
import { getSearchParams, setRacesDetailLoading} from "@/app/utils/Common";

const Title = styled.div`
  width: 100%;
  height: 36px;
  line-height: 16px;
  padding: 10px 12px;
  ${text_size(15)}
  font-weight: 500;
  background-color: #F4F4F4;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 10%);
`;

const TableTitle = styled.div`
  width: 100%;
  display: flex;
  height: 36px;
  padding:10px 8px;
  justify-content: space-between;
  background: rgba(97, 118, 160, 1);
  ${text_size(13)}
  font-weight: 500;
  color: rgba(255, 255, 255, 1);

`;
const StyledTableHeadCell = styled(TableCell)<{ ismobile?: boolean, index?: number }>(({ ismobile, index }) => ({
    [`&.${tableCellClasses.root}`]: {
        width: index == 0 ? "6%" : index == 1 ? "30%" : "11%",
        ...textSize(11),
        fontWeight: 400,
        height: "32px",
        padding: ismobile ? "8px 8px 8px 12px" : "4px 8px",
        lineHeight: "inherit",
        textAlign: index == 1 ? "left" : "center",
        paddingLeft: index == 1 ? "44px" : ""
    },
}));
const MStyledTableHeadCell = styled(TableCell)<{ ismobile?: boolean, index?: number }>(({ ismobile, index }) => ({
    [`&.${tableCellClasses.root}`]: {
        ...textSize(11),
        fontWeight: 400,
        height: "32px",
        padding: "8px 8px 8px 12px",
        lineHeight: "inherit",
        textAlign: index == 1 ? "left" : "center",
        width: index == 0 ? "60px" : index == 2 ? "100px" : ''
    }
}));

const StyledTableHeadRow = styled(TableHead)(() => ({
    [`&.${tableHeadClasses.root}`]: {
        background: "rgba(225, 225, 225, 1)"
    },
    'th': {
        color: "#333333"
    },
    'th: first-child': {
        paddingRight: "8px",
        paddingLeft: "15px",
    }
}));

const StyledTableCell = styled(TableCell)<{ ismobile?: boolean, ischinese?: boolean }>(({ ismobile, ischinese }) => ({
    [`&.${tableCellClasses.root}`]: {
        color: "#333333",
    },
    [`&.${tableCellClasses.body}`]: {
        ...textSize(13),
        fontWeight: 500,
        padding: "8px 12px",
        verticalAlign: "middle",
        textAlign: "center",
        height: "32px",
        // width: ischinese ? "25%" : "50%",
        lineHeight: ismobile ? "17px" : "24px"
    },
    // [`&.mSecondCell div`]: {
    //     lineHeight: "18px",
    //     'p span': {
    //         display: "inline-block",
    //         minWidth: "36px",
    //         paddingRight: "12px"
    //     },
    //     'p:first-child span': {
    //         fontWeight: "300",
    //         color: "#122C68"
    //     },
    //     'p:first-child': {
    //         lineHeight: "14px",
    //     },
    //     "p span:last-child ": {
    //         paddingRight: "0"
    //     }
    // }
}));

const StyledTableRow = styled(TableRow)<{ ismobile?: boolean }>(({ ismobile }) => ({
    '&.mTabRow2': {
        backgroundColor: "#F4F4F4",
    },
    '&.mTabRow1': {
        backgroundColor: "#FFFFFF",
    },
    '&:nth-of-type(odd) td': {
        padding: ismobile ? "8px 12px 0px 12px" : "",
        backgroundColor: ismobile ? '' : "#FFFFFF",
    },
    '&:nth-of-type(even) td': {
        padding: ismobile ? "4px 12px 8px" : "",
        backgroundColor: ismobile ? '' : "#F4F4F4",
    },
    'td, th': {
        border: 0,
    },
    'td:last-child, th:last-child': {
        paddingRight: "8px",
    },
    'td: first-child': {
        paddingRight: "8px",
        paddingLeft: "15px",
        ...textSize(15)
    }
}));

const TableHeadRowSecondM = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        background: 'none'
    },
    '&:nth-of-type(even)': {
        background: 'none'
    }
}));

const TableCellSecondM = styled(TableCell)(() => ({
    fontSize: "13px !important ",
    [`@media only screen and (min-width: 1680px)`]: { fontSize: "15px !important",},
    padding: "0 8px 0 0 !important",
    [`&.${tableCellClasses.head}`]: {
        fontWeight: "300",
        color: "#122C68",
        lineHeight: "14px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontWeight: "500",
        color: "#333333",
        lineHeight: "18px",
        wordBreak: "break-all"
    }
}));

const StyledEmptyDiv = styled('div')(() => ({
    padding: "8px 15px"
}));

// Final Declaration
const StyledDeclDiv = styled('div')(() => ({
    padding: "12px",
    ...textSize(11),
    fontWeight: "500",
    color: "#333333"
}));

const DisclaimerWrapper = styled.div<{ ismobile?: boolean }>`
    padding: 12px;
    max-width: ${({ ismobile }) => (ismobile ? "100%" : "943px")};
`;

interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
}

const rows = [
    { rank: 1, imgPath: "", jockey: { value: "Camilo Ospina" }, firstPlace: "112", secondPlace: "73", thirdPlace: "54", totalRun: "633", strikeRate: "17.7%" },
    { rank: 2, imgPath: "", jockey: { value: "Adel Alfouraidi" }, firstPlace: "112", secondPlace: "73", thirdPlace: "54", totalRun: "633", strikeRate: "17.7%" },
    { rank: 3, imgPath: "", jockey: { value: "Alexis Moreno" }, firstPlace: "112", secondPlace: "73", thirdPlace: "54", totalRun: "633", strikeRate: "17.7%" },
    { rank: 4, imgPath: "", jockey: { value: "Luis Morales" }, firstPlace: "112", secondPlace: "73", thirdPlace: "54", totalRun: "633", strikeRate: "17.7%" },
    { rank: 5, imgPath: "", jockey: { value: "Naif Alanazi" }, firstPlace: "112", secondPlace: "73", thirdPlace: "54", totalRun: "633", strikeRate: "17.7%" }
]

const JockeyTrainerRanking: React.FC<propType> = (props: propType) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [entryRecords, setEntryRecords] = useState<any[]>(rows);
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [rankingData, setRankingData] = useState<any>(null);
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));

    useEffect(() => {
        if (myContextState.isLoadingRaces) return;
        if (!myContextState.selectedMeeting?.displayName) {
            setRacesDetailLoading(props.setRacesDetailLoading)
            return
        }

        getJockeysTrainersRanking(lang.langCode, myContextState.season, myContextState.selectedMeeting?.displayName)
            .then((res: any) => {
                //setTrackAnalysisData(res?.item);
                //console.log("getJockeysTrainersRanking",res ,res?.item, myContextState.season, myContextState.selectedMeeting?.displayName)
                const rankinglist = [] as any[];
                res?.item?.children?.forEach((tab: any) => {
                    if (tab?.location?.value && tab?.location?.value != "") {
                        const jockeysRankingList = handedRankingData(tab?.jockeysRanking?.value);
                        const trainersRankingList = handedRankingData(tab?.trainersRanking?.value);
                        rankinglist.push({
                            lable: tab?.location?.value,
                            //jockeysLastUpdate: tab?.jockeysLastUpdate?.value,
                            jockeysSourceLastUpdated: tab?.jockeysSourceLastUpdated?.value,
                            jockeysRanking: jockeysRankingList,
                            //trainersLastUpdate: tab?.trainersLastUpdate?.value,
                            trainersSourceLastUpdated: tab?.trainersSourceLastUpdated?.value,
                            trainersRanking: trainersRankingList
                        });
                    }
                });
                setRankingData(rankinglist);
            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
            });        
    }, [myContextState.season, myContextState.selectedMeeting?.displayName]);
    console.log("rankingData", rankingData)

    const handedRankingData = (data: any) => {
        const tblData = new PlainTextTable(data);
        return { headerData: tblData?.headers || [], bodyData: tblData?.contents?.byRow || [] };
    }
    return (
        <>
            {props.type === "pc" ?
                (
                    rankingData?.length?
                    <div style={{ background: "#FFFFFF", borderRadius: "0px 0px 4px 4px" }}>
                        <Title id="jockeyTrainerRanking_title">{t("jockeyTrainerRanking_title")}</Title>
                        {rankingData?.map((item: any) => (
                            <>
                                <TableTitle id="jockeyTrainerRanking_location_pc">{item.lable}</TableTitle>

                                <TableContainer sx={{ display: "flex", borderRadius: "0px 0px 4px 4px" }}>
                                    <Table id="jockeyTrainerRanking_table_jockey_pc" sx={{ width: "100%" }} aria-label="simple table">
                                        <StyledTableHeadRow>
                                            {item?.jockeysRanking?.headerData?.map((header: any, index: number) => (
                                                <StyledTableHeadCell key={item.lable + header} index={index}>{header}</StyledTableHeadCell>
                                            ))}
                                        </StyledTableHeadRow>
                                        <TableBody>
                                            {item?.jockeysRanking?.bodyData.map((row: any, ri: number) => (
                                                <StyledTableRow key={item.lable + ri}>
                                                    {
                                                        row.map((val: any, i: number) => (
                                                            <StyledTableCell key={item.lable + val} sx={{ paddingLeft: i == 1 ? "44px !important" : '', textAlign: i == 1 ? "left !important" : '' }}>
                                                                {i == 1 ? (<img src='' />) : ''}
                                                                {val}
                                                            </StyledTableCell>
                                                        ))
                                                    }
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <StyledDeclDiv id="jockeyTrainerRanking_informationSource_lastUpdate_jockey_pc">
                                    <div dangerouslySetInnerHTML={{ __html: item?.jockeysSourceLastUpdated}}></div>
                                    {/* <p>{item?.jockeysInformationSource}</p>
                                    <p>{item?.jockeysLastUpdate}</p> */}
                                </StyledDeclDiv>

                                <TableContainer sx={{ display: "flex", borderRadius: "0px 0px 4px 4px" }}>
                                    <Table id="jockeyTrainerRanking_table_trainer_pc" sx={{ width: "100%" }} aria-label="simple table">
                                        <StyledTableHeadRow>
                                            {item?.trainersRanking?.headerData?.map((header: any, index: number) => (
                                                <StyledTableHeadCell key={index} index={index}>{header}</StyledTableHeadCell>

                                            ))}
                                        </StyledTableHeadRow>
                                        <TableBody>
                                            {item?.trainersRanking?.bodyData?.map((row: any, ri: number) => (
                                                <StyledTableRow key={item.lable + ri}>
                                                    {
                                                        row.map((val: any, i: number) => (
                                                            <StyledTableCell key={item.lable + val} sx={{ paddingLeft: i == 1 ? "44px !important" : '', textAlign: i == 1 ? "left !important" : '' }}>
                                                                {i == 1 ? (<img src='' />) : ''}
                                                                {val}
                                                            </StyledTableCell>
                                                        ))
                                                    }
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <StyledDeclDiv id="jockeyTrainerRanking_informationSource_lastUpdate_trainer_pc">
                                    <div dangerouslySetInnerHTML={{ __html: item?.trainersSourceLastUpdated}}></div>
                                    {/* <p>{item?.trainersInformationSource}</p>
                                    <p>{item?.trainersLastUpdate}</p> */}
                                </StyledDeclDiv>
                            </>
                        ))} 
                        <DisclaimerWrapper><Disclaimer /></DisclaimerWrapper>
                    </div>
                    :
                    <>
                    <Title id="jockeyTrainerRanking_title">{t("jockeyTrainerRanking_title")}</Title>
                    <NoInformation/>
                    </>
                  
                ) : (
                    rankingData?.length?
                    <>
                        <div style={{ background: "#FFFFFF", boxShadow: "0px 2px 10px 0px #0000001A", borderRadius: "0px 0px 4px 4px"}}>
                            {rankingData?.map((item: any) => (
                                <>
                                    <TableTitle id="jockeyTrainerRanking_location_mobile">{item?.lable}</TableTitle>
                                    <TableContainer sx={{ display: "flex", borderRadius: "0px 0px 4px 4px" }}>
                                        <Table id="jockeyTrainerRanking_table_jockey_mobile" sx={{ width: "100%" }} aria-label="simple table">
                                            <StyledTableHeadRow>
                                                {item?.jockeysRanking?.headerData?.filter((x: any, i: number) => i <= 1 || i == item?.jockeysRanking?.headerData.length - 1).
                                                    map((header: any, index: number) => (
                                                        <MStyledTableHeadCell key={index} ismobile index={index}>{header}</MStyledTableHeadCell>
                                                    ))}
                                            </StyledTableHeadRow>
                                            <TableBody>
                                                {item?.jockeysRanking?.bodyData.map((row: any, ri: number) => (
                                                    <>
                                                        <StyledTableRow ismobile className={ri % 2 != 1 ? "mTabRow1" : "mTabRow2"} key={row.rank}>
                                                            {row.filter((x: any, i: number) => i <= 1 || i == row?.length - 1)?.
                                                                map((line: any, li: number) => (
                                                                    <StyledTableCell ismobile key={item?.lable + line} sx={{ textAlign: li == 1 ? "left !important" : "" }}>
                                                                        <p>{line}</p>
                                                                    </StyledTableCell>
                                                                ))}
                                                        </StyledTableRow>
                                                        <StyledTableRow ismobile className={ri % 2 != 1 ? "mTabRow1" : "mTabRow2"}>
                                                            <StyledTableCell ismobile>
                                                                <p><img src={row.imgPath} /></p>
                                                            </StyledTableCell>
                                                            <StyledTableCell ismobile colSpan={2} sx={{ textAlign: "left !important" }}>
                                                                <Table sx={{ width: "inherit" }}>
                                                                    <TableHead>
                                                                        <TableHeadRowSecondM>
                                                                            {item?.jockeysRanking?.headerData?.filter((x: any, i: number) => i > 1 && i < item?.jockeysRanking?.headerData.length - 1).
                                                                                map((header: any, index: number) => (
                                                                                    <TableCellSecondM sx={{width: index <= 2 ? "42px" : "inherit"} } key={header + index}>{header}</TableCellSecondM>
                                                                                ))}
                                                                        </TableHeadRowSecondM>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        <TableHeadRowSecondM>
                                                                            {row.filter((x: any, i: number) => i > 1 && i < row?.length - 1)?.
                                                                                map((line: any, li: number) => (
                                                                                    <TableCellSecondM sx={{width: li <= 2 ? "42px" : "inherit"} } key={line + li}>{line}</TableCellSecondM>
                                                                                ))}
                                                                        </TableHeadRowSecondM>
                                                                    </TableBody>
                                                                </Table>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <StyledDeclDiv id="jockeyTrainerRanking_informationSource_lastUpdate_jockey_mobile">
                                        <div dangerouslySetInnerHTML={{ __html: item?.jockeysSourceLastUpdated}}></div>
                                        {/* <p>{item?.jockeysInformationSource}</p>
                                        <p>{item?.jockeysLastUpdate}</p> */}
                                    </StyledDeclDiv>

                                    <TableContainer sx={{ display: "flex", borderRadius: "0px 0px 4px 4px" }}>
                                        <Table id="jockeyTrainerRanking_table_trainer_mobile" sx={{ width: "100%" }} aria-label="simple table">
                                            <StyledTableHeadRow>
                                                {item?.trainersRanking?.headerData?.filter((x: any, i: number) => i <= 1 || i == item?.trainersRanking?.headerData.length - 1).
                                                    map((header: any, index: number) => (
                                                        <MStyledTableHeadCell key={item.lable + header + index} ismobile index={index}>{header}</MStyledTableHeadCell>
                                                    ))}
                                            </StyledTableHeadRow>
                                            <TableBody>
                                                {item?.trainersRanking?.bodyData.map((row: any, ri: number) => (
                                                    <>
                                                        <StyledTableRow ismobile className={ri % 2 != 1 ? "mTabRow1" : "mTabRow2"} key={row.rank}>
                                                            {row.filter((x: any, i: number) => i <= 1 || i == row?.length - 1)?.
                                                                map((line: any, li: number) => (
                                                                    <StyledTableCell ismobile key={item?.lable + line} sx={{ textAlign: li == 1 ? "left !important" : "" }}>
                                                                        <p>{line}</p>
                                                                    </StyledTableCell>
                                                                ))}
                                                        </StyledTableRow>
                                                        <StyledTableRow ismobile className={ri % 2 != 1 ? "mTabRow1" : "mTabRow2"}>
                                                            <StyledTableCell ismobile>
                                                                <p><img src={row.imgPath} /></p>
                                                            </StyledTableCell>
                                                            <StyledTableCell ismobile colSpan={2} sx={{ textAlign: "left !important" }}>
                                                                <Table sx={{ width: "inherit" }}>
                                                                    <TableHead>
                                                                        <TableHeadRowSecondM>
                                                                            {item?.trainersRanking?.headerData?.filter((x: any, i: number) => i > 1 && i < item?.trainersRanking?.headerData.length - 1).
                                                                                map((header: any, index: number) => (
                                                                                    <TableCellSecondM sx={{width: index <= 2 ? "42px" : "inherit"}} key={header + index}>{header}</TableCellSecondM>
                                                                                ))}
                                                                        </TableHeadRowSecondM> 
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        <TableHeadRowSecondM>
                                                                            {row.filter((x: any, i: number) => i > 1 && i < row?.length - 1)?.
                                                                                map((line: any, li: number) => (
                                                                                    <TableCellSecondM sx={{width: li <= 2 ? "42px" : "inherit"}} key={line + li}>{line}</TableCellSecondM>
                                                                                ))}
                                                                        </TableHeadRowSecondM>
                                                                    </TableBody>
                                                                </Table>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <StyledDeclDiv id="jockeyTrainerRanking_informationSource_lastUpdate_trainer_mobile">
                                        <div dangerouslySetInnerHTML={{ __html: item?.trainersSourceLastUpdated}}></div>
                                        {/* <p>{item?.trainersInformationSource}</p>
                                        <p>{item?.trainersLastUpdate}</p> */}
                                    </StyledDeclDiv>
                                </>
                            ))}
                            <DisclaimerWrapper ismobile><Disclaimer /></DisclaimerWrapper>
                        </div>
                    </>
                    :
                    <NoInformation/>
                )
            }
        </>
    )
}

export default JockeyTrainerRanking;